<template>
    <div class="home">
        <page-header></page-header>
        <div class="leftMenu">
            <ul class="myMenu lm" id="btm">
                <li data-menuanchor="firstPage"><span data-menuanchor="firstPage"  class="menu ">01</span>
                </li>
                <li data-menuanchor="secondPage"><span data-menuanchor="secondPage" class="menu">02</span></li>
                <li data-menuanchor="thirdPage"><span data-menuanchor="thirdPage"  class="menu">03</span>
                </li>
                <li data-menuanchor="fourthPage"><span data-menuanchor="fourthPage" class="menu">04</span></li>
            </ul>
        </div>
        <full-page ref="fullpage" :options="options" id="fullpage">
            <div class="section" id="section1" data-anchor="firstPage">
                <div class="home_content align_center">
                    <div class="s1_main align_center">
                        <div class="s1_article">
                            <div class="s1_article_content">Dgmong co.</div>
                            <div class="s1_article_title">Dreams of Great <br> Developers!</div>
                            <div class="s1_article_content">
                                디지몽은 웹 서비스, 어플리케이션을 개발하는 전문 개발사로<br/>
                                IOT, AI, 플랫폼사업등 다양한 분야의 서비스를 제공하고 있으며<br/>
                                항상 새로운 영역에 대한 도전과 탐구를 멈추지 않는 최고의 업체입니다.<br/>
                                디지몽은 성공적인 사업파트너로써 홈페이지를 무사히 오픈하고 유지할수 있도록<br/>
                                여러분의 비즈니스를 도와드립니다.<br/>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="contact_us">
                    <div class="contact_us_title">Contact us</div>
                    <br/>
                    <div class="contact_us_content">6F, 54, Changeop-ro, Sujeong-gu, Seongnam-si, Gyeonggi-do <br/>
                        woong@dgmong.com
                    </div>
                </div>


            </div>


            <div class="section" id="section2" data-anchor="secondPage">
                <div class="home_content align_center">
                    <div class="s2_main align_center">
                        <div class="s2_main_inner s2_main_lt">
                            <div class="s2_main_title ">응용프로그램 개발</div>
                            <br/>
                            <div class="s2_main_content">
                                <ul>
                                    <li>안드로이드 & IOS 어플리케이션 개발</li>
                                    <li>AI 모델링 설계 및 데이터 마이닝작업</li>
                                    <li><br></li>
                                </ul>
                            </div>
                        </div>
                        <div class="s2_main_inner s2_main_rt">
                            <div class="s2_main_title ">웹 개발</div>
                            <br/>
                            <div class="s2_main_content">
                                <ul>
                                    <li>LMS 서비스 개발</li>
                                    <li>반응형 웹 사이트 개발</li>
                                    <li>쇼핑몰 및 커뮤니티 사이트 개발</li>
                                </ul>
                            </div>
                        </div>
                        <div class="s2_main_inner s2_main_lb">
                            <div class="s2_main_title ">웹 서비스 기획</div>
                            <br/>
                            <div class="s2_main_content">
                                <ul>
                                    <li>분석 & 리서치 서비스</li>
                                    <li>요건정의서 & 기능정의서 서비스</li>
                                    <li>화면설계서 & 와이어 프레임 서비스</li>
                                </ul>
                            </div>
                        </div>
                        <div class="s2_main_inner s2_main_rb">
                            <div class="s2_main_title ">웹 디자인</div>
                            <br/>
                            <div class="s2_main_content">
                                <ul>
                                    <li>웹 사이트 UI, UX</li>
                                    <li>웹 사이트 페이지 디자인</li>
                                    <li><br></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="section" id="section3" data-anchor="thirdPage">
                <div class="home_content align_center">
                    <div class="s3_wrap align_center">
                        <div class="s3_slogan_wrap">
                            <div class="s3_slogan">Dreams of Great <br/> Developers!</div>
                        </div>
                        <div class="s3_main_wrap">
                            <div class="s3_main">
                                <div class="s3_main_txt">
                                    <div class="s3_main_title">AI/IOT Solution</div>
                                    <div class="s3_main_content">NFC 연동, 스마트 팩토리 센서 연동 및<br/>데이터 마이닝, AI 추천 및 분석 보유
                                    </div>
                                </div>
                                <div class="s3_main_img">
                                    <img src="@/assets/image/work_1.jpg" alt="">
                                </div>
                            </div>
                            <div class="s3_main">
                                <div class="s3_main_txt">
                                    <div class="s3_main_title">인프라/기획 컨설팅</div>
                                    <div class="s3_main_content">AWS 파트너 링크, 보안 시스템 구축,<br/>체계적인 기획 시스템 제공</div>
                                </div>
                                <div class="s3_main_img">
                                    <img src="@/assets/image/work_2.jpg" alt="">
                                </div>
                            </div>
                            <div class="s3_main">
                                <div class="s3_main_txt">
                                    <div class="s3_main_title">Commerce Platform</div>
                                    <div class="s3_main_content">쇼핑몰, 오픈마켓, 구독서비스, <br/> 커스텀 몰 자체 제작 솔루션 보유</div>
                                </div>
                                <div class="s3_main_img">
                                    <img src="@/assets/image/work_3.jpg" alt="">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="section" id="section4" data-anchor="fourthPage">
                <div class="s4_bg">
                    <div class="s4_main_wrap">

                    <div class="s4_main">
                        <div class="s4_title">문의하기</div>
                        <div class="s4_content">디지몽은 다양한 프로젝트 경험과 구성인력의 전문화를 통해 <br/>
                            합리적인 비용으로 성공적인 프로젝트를 진행합니다.
                        </div>
                        <a class="contact_box" href="mailto:woong@dgmong.com">이메일문의 <span class="contact_email">woong@dgmong.com</span>
                        </a>

                    </div>
                </div>
                    </div>

                <div class="s4_footer">
                    <div class="s4_sub_addr">경기 성남시 수정구 창업로 54 판교제2테크노밸리 기업성장센터 604호　|　E-MAIL :
                        woong@dgmong.com
                        <br/>사업자등록번호 : 595-30-00072　|　개인정보보호책임자 : 전은수　|　Copyright © 2017 DGMONG
                        corp.
                        All rights reserved
                    </div>
                </div>


            </div>
        </full-page>

    </div>

</template>

<script>
    // @ is an alias to /src
    import 'fullpage.js/dist/fullpage.css'

    export default {
        name: 'Home',
        mixins: [],
        components: {},
        props: {},
        data() {
            return {
                options: {
                    autoScrolling: true,
                    fitToSection: true,
                    v2compatible: true,
                    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
                    sectionsColor: ['#ffeecf', '#f7c7f3', '#ffffff', '#222222'],
                    lockAnchors: true,
                    navigation: false,
                    verticalCentered: false,
                    anchors: ['firstPage', 'secondPage', 'thirdPage', 'fourthPage'],
                    menu: '.myMenu',

                },
            }
        },
        beforeRouterEnter() {
        },
        created() {
            $(function () {
                $("html").animate({scrollTop: 0}, "slow");

            });
            $(document).on('click', '#moveTo', function () {
                fullpage_api.moveTo('firstPage');
            });
        },
        mounted() {
            document.body.addEventListener('scroll', this.handleScroll);

        },
        beforeDestroy() {
        },
        destroyed() {
            document.body.removeEventListener('scroll', this.handleScroll);

        },
        computed: {},
        methods: {
            handleScroll() {
                document.getElementById('header').style.left = 0 - document.body.scrollLeft + 'px';
                document.getElementById('btm').style.left = 0 - document.body.scrollLeft + 'px';

            },
        },
        watch: {},
    }
</script>
